import React from 'react';
import fondo from '../../../assets/ff.png';
import './Fondo.css';
import { Link } from 'react-router-dom';


const Fondo = () => {
    return (
        <div className='fondo-header'>
            <img src={fondo} alt="Fondo" />
            <div className="overlay">
                <h1 className="title">Los Mejores Productos <br/> <span className='span'>Lo Encuentras Aqui</span></h1>
                {/* <a href="/co" className="contact-button">Contáctanos</a> */}

                <Link className='contact-button' to="/contacto">Contactanos</Link>

            </div>
        </div> 
    );
}

export default Fondo;
    